// The axios layer has no React. When a refresh fails it can only announce that
// the session is over; useFindUser listens and drops `user`, and ProtectedRoute
// (keyed on user?.uuid) is what actually moves the person to /login.
const SESSION_ENDED = "qoldau:session-ended";

export const endSession = () => {
  window.dispatchEvent(new Event(SESSION_ENDED));
};

export const onSessionEnded = (handler) => {
  window.addEventListener(SESSION_ENDED, handler);
  return () => window.removeEventListener(SESSION_ENDED, handler);
};
